import React from 'react';
import PropTypes from 'prop-types';

function MicVocal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M11 7.601L5.006 15.791C4.86496 15.9837 4.79751 16.2204 4.81585 16.4585C4.83419 16.6966 4.93711 16.9202 5.106 17.089L5.923 17.907C6.09435 18.0782 6.32199 18.1813 6.56366 18.1973C6.80532 18.2133 7.04458 18.1411 7.237 17.994L15.09 12M16.5 21.174C15.5 20.5 14.372 20 13 20C10.942 20 9.072 22.356 7 22C4.928 21.644 4.225 18.631 5.5 17.5M21 7C21 9.76142 18.7614 12 16 12C13.2386 12 11 9.76142 11 7C11 4.23858 13.2386 2 16 2C18.7614 2 21 4.23858 21 7Z"
        strokeLinecap="round"
      />
    </svg>
  );
}

MicVocal.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default MicVocal;
